/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rscu_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amino acids encoded by a single codon — methionine (ATG) and tryptophan (TGG) — have no synonymous alternatives, so their RSCU is always 1.`)
};

const es_rscu_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los aminoácidos codificados por un solo codón — metionina (ATG) y triptófano (TGG) — no tienen alternativas sinónimas, así que su RSCU siempre es 1.`)
};

const de_rscu_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aminosäuren, die durch ein einziges Codon kodiert werden — Methionin (ATG) und Tryptophan (TGG) — haben keine synonymen Alternativen, sodass ihr RSCU-Wert immer 1 ist.`)
};

const nl_rscu_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aminozuren gecodeerd door één enkel codon — methionine (ATG) en tryptofaan (TGG) — hebben geen synonieme alternatieven, dus hun RSCU is altijd 1.`)
};

const fr_rscu_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les acides aminés codés par un seul codon — méthionine (ATG) et tryptophane (TGG) — n'ont pas d'alternatives synonymes, donc leur RSCU est toujours 1.`)
};

const it_rscu_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gli amminoacidi codificati da un solo codone — metionina (ATG) e triptofano (TGG) — non hanno alternative sinonime, quindi il loro RSCU è sempre 1.`)
};

const pt_br2_rscu_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aminoácidos codificados por um único códon — metionina (ATG) e triptofano (TGG) — não têm alternativas sinônimas, então seu RSCU é sempre 1.`)
};

const pt_rscu_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os aminoácidos codificados por um único codão — metionina (ATG) e triptofano (TGG) — não têm alternativas sinónimas, pelo que o seu RSCU é sempre 1.`)
};

const ja_rscu_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`単一のコドンでコードされるアミノ酸 — メチオニン (ATG) とトリプトファン (TGG) — には同義の代替がないため、RSCUは常に1です。`)
};

const zh_rscu_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`由单一密码子编码的氨基酸——甲硫氨酸（ATG）和色氨酸（TGG）——没有同义的替代密码子，因此它们的 RSCU 始终为 1。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rscu_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rscu_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rscu_faq_a4", locale)
	if (locale === "en") return en_rscu_faq_a4(inputs)
	if (locale === "es") return es_rscu_faq_a4(inputs)
	if (locale === "de") return de_rscu_faq_a4(inputs)
	if (locale === "nl") return nl_rscu_faq_a4(inputs)
	if (locale === "fr") return fr_rscu_faq_a4(inputs)
	if (locale === "it") return it_rscu_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_rscu_faq_a4(inputs)
	if (locale === "pt") return pt_rscu_faq_a4(inputs)
	if (locale === "ja") return ja_rscu_faq_a4(inputs)
	return zh_rscu_faq_a4(inputs)
};